// removed by extract-text-webpack-plugin
module.exports = {"container":"_2dLNwE-CMMUm_FBJBpAl0M"};


//////////////////
// WEBPACK FOOTER
// ./src/App/Pages/Documents/Document/SendToSign/OwnerView/styles.css
// module id = 2763
// module chunks = 0